import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineFormat extends TitleBase {
	private disciplineValue: string;
	private formatValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.formatValue = this.getFilterValue(ParameterType.ATTENDANCE);
		const countryContinentFilter = this.filters.filter(
			(_) => _.values.length > 1 && (_.type === ParameterType.COUNTRY || _.type === ParameterType.CONTINENT)
		);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.ATTENDANCE) &&
			countryContinentFilter.length === 0
		);
	}

	protected getPageTitle(): string {
		return `${this.formatValue} ${this.titlePortalType} in ${this.disciplineValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.formatValue.toLowerCase()} ${this.titlePortalType} in the field of ${this.disciplineValue}`,
			' worldwide'
		);
	}
}
